/**
 * Request queue manager to throttle API requests
 */

export class RequestQueue {
  constructor(minInterval = 1000) {
    this.queues = {
      users: [],
      charts: [],
      artists: []
    };
    this.minInterval = minInterval;
    this.lastFetch = Date.now() - minInterval;
  }

  /**
   * Add a request to the appropriate queue
   * @param {string} type - Type of request (users, charts, artists)
   * @param {Object} request - Request object with url and handler
   */
  add(type, request) {
    if (this.queues[type]) {
      this.queues[type].push(request);
    }
  }

  /**
   * Process the next request if enough time has passed
   */
  async process() {
    if (Date.now() < this.lastFetch + this.minInterval) {
      return;
    }

    const req = this.queues.users.pop() ||
                this.queues.artists.pop() ||
                this.queues.charts.pop();

    if (!req) {
      return;
    }

    try {
      const response = await fetch(req.url);
      const json = await response.json();
      req.handler(json);
      this.lastFetch = Date.now();
    } catch (error) {
      console.error('Queue fetch error:', error);
    }
  }

  /**
   * Clear all queues
   */
  clear() {
    this.queues.users = [];
    this.queues.charts = [];
    this.queues.artists = [];
  }

  /**
   * Clear a specific queue
   * @param {string} type - Type of queue to clear
   */
  clearQueue(type) {
    if (this.queues[type]) {
      this.queues[type] = [];
    }
  }
}
